<template>
    <trax-ui-card :title="cardTitle" :title-bold="titleBold" title-no-padding="1" v-show="visible && allowed && atpDafEditStatus">

        <p class="pt-3" v-html="text" v-if="text"></p>

        <form autocomplete="off" class="trax-form mb-4" v-if="!computedDisableComments">

            <trax-ui-input :placeholder="commentsPlaceholder" :required="requiredComment"
                :rows="commentsRows" v-model="form.comments" :error="errors.comments">
            </trax-ui-input>

        </form>

        <!-- Signature buttons -->

        <div class="mt-3 text-right">
            <button class="btn btn-round btn-default" @click="signAlt()" v-if="dataPropAlt">
                {{ signButtonLabelAlt }}
            </button>    

            <button class="btn btn-round btn-danger" @click="sign()">
                {{ signButtonLabel }}
            </button>    
        </div>

        <!-- Signature modal -->

        <trax-ui-modal-default :id="id+'-sign-'+dataProp" :bus="bus" :title="lang.polaris.dashboard.signature">
            <enac-atpl-dashboard-item-save-sign-popup :id="id+'-sign-'+dataProp" :bus="bus" simple-text="1"></enac-atpl-dashboard-item-save-sign-popup>
        </trax-ui-modal-default>

    </trax-ui-card>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-procedure-atp-daf-edit'},
            permission: null,
            signProp: null,
            signPropAlt: null,
            dataProp: null,
            dataPropAlt: null,
            visibleWhen: null,
            hiddenWhen: null,
            hiddenWhenOr: null,
            requiredComment: null,
            cardTitle: { default: lang.polaris.procedure.validation },
            commentsPlaceholder: { default: lang.polaris.procedure.comments },
            commentsRows: { default: 5 },
            titleBold: { default: 0 },
            text: null,
            disableComments: { default: 0 },
            signButtonLabel: { default: lang.polaris.procedure.validate },
            signButtonLabelAlt: { default: lang.polaris.procedure.reject }
        },

        data: function() {
            return {
                lang: lang,
                user: user,
                procedureUserId: null,
                endpoint: app_url+'polaris/api/front/procedures/'+data.procedure.id,
                registration: data.registration,
                form: {
                    comments: '',
                },
                errors: {},
                visible: false,
                altEvent: false,
                bus: this.$bus
            }
        },
        
        computed: {

            computedDisableComments: function() {
                return parseInt(this.disableComments);
            },

            allowed: function() {
                if (this.user.admin) return true;
                if (this.permission == 'learner') {
                    return this.user.id == this.procedureUserId;
                }
                var userFunction = this.user.user_function;
                if (!userFunction) return false;
                if (this.permission == 'client') {
                    return userFunction == 'client';
                }
                if (this.permission == 'training') {
                    return userFunction == 'training' || userFunction == 'training_op';
                }
                if (this.permission == 'op') {
                    return userFunction == 'op' || userFunction == 'training_op';
                }
            },

            atpDafEditStatus: function() {
                return this.registration.status != 'draft' && this.registration.status != 'archived';
            }
        },

        created: function() {
            this.bus.$on(this.id+'-data', this.setData);
            this.bus.$on(this.id+'-updated', this.setData);
            this.bus.$on(this.id+'-errors', this.setErrors);
            this.bus.$on(this.id+'-sign-'+this.dataProp+'-created', this.signed);
        },

        methods: {

            setData(procedure) {
                this.procedureUserId = procedure.user_id;
                this.visible = procedure.data[this.visibleWhen] 
                    && !procedure.data[this.dataProp]
                    && (!this.dataPropAlt || !procedure.data[this.dataPropAlt])
                    && (!this.hiddenWhen || !procedure.data[this.hiddenWhen])
                    && (!this.hiddenWhenOr || !procedure.data[this.hiddenWhenOr]);
            },

            sign() {
                this.altEvent = false;
                this.signed();
            },

            signAlt() {
                this.altEvent = true;
                this.signed();
            },

            signNow() {
                this.bus.$emit(this.id+'-sign-'+this.dataProp+'-create');
            },

            signed(feedback) {
                var dataProp = this.altEvent ? this.dataPropAlt : this.dataProp;
                var signProp = this.altEvent ? this.signPropAlt : this.signProp;
                var data = {sign: signProp, data: {}}
                this.errors = {};
                if (this.computedDisableComments) {
                    data.data[dataProp] = {};
                } else {
                    data.data[dataProp] = { comments: this.form.comments };
                }
                if (feedback == undefined) data.preflight = true;
                this.putData(data);
            },

            putData(data) {
                var that = this;
                axios.put(this.endpoint, data)
                    .then(function (response) {
                        if (response.status == 204) return that.signNow();
                        location.reload();
                        /*
                        that.setData(response.data);
                        that.bus.$emit(that.id+'-updated', response.data.data);
                        that.bus.$emit(that.id+'-toastr-success', response.data.data);
                        */
                    })
                    .catch(function (error) {
                        if (error.response.data.errors) {
                            that.processErrors(error.response.data.errors);
                            that.bus.$emit(that.id+'-toastr-error', that.lang.polaris.form.form_error);
                        } else {
                            that.bus.$emit(that.id+'-toastr-error', error.response.data);
                        }
                    });
            },

            processErrors(errors) {
                for (var name in errors) {
                    var error = errors[name];
                    if (error instanceof Array) errors[name] = error[0];
                }
                this.setErrors(errors);
            },

            setErrors(errors) {
                var my_errors = {};
                for (var index in errors) {
                    my_errors[index.split('.')[1]] = errors[index];
                }
                this.errors = my_errors;
            }

        }
    }
</script>
